export enum EntitySourceType {
  OPERATIONAL = "operational",
  OLD = "old",
  CLIENT_HIERARCHY = "client-hierarchy"
}
